import { c as _c } from "react/compiler-runtime";
import { Avatar, HStack, VStack, Text, type StackProps } from '@chakra-ui/react';
import { Icon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
interface FGQuoteCardProps {
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personTitle?: string;
  personAvatarUrl?: string;
  companyName?: string;
  quote: string;
  bgColor?: string;
  color?: string;
  id?: string;
  minimal?: boolean;
  stackProps?: StackProps;
}
const FGQuoteCard: React.FC<FGQuoteCardProps> = t0 => {
  const $ = _c(58);
  const {
    personFullName,
    personFirstName,
    personLastName,
    personTitle,
    personAvatarUrl,
    companyName,
    quote,
    id,
    minimal,
    stackProps
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t1 = minimal ? "none" : "2xl";
  const t2 = minimal ? "none" : "xl";
  let t3;
  if ($[0] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 8]);
    $[0] = getBreakpointValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== getBreakpointValue || $[3] !== minimal) {
    t4 = minimal ? getBreakpointValue([0]) : getBreakpointValue([4, 8]);
    $[2] = getBreakpointValue;
    $[3] = minimal;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== getBreakpointValue) {
    t5 = getBreakpointValue([4, 8]);
    $[5] = getBreakpointValue;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Icon as={FaQuoteLeft} boxSize={t5} color="primary" />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== getBreakpointValue) {
    t7 = getBreakpointValue([2, 4]);
    $[9] = getBreakpointValue;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <Icon as={FaQuoteRight} boxSize={t7} color="primary" opacity={0.5} />;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <HStack>{t6}{t8}</HStack>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== getBreakpointValue) {
    t10 = getBreakpointValue(["sm", "lg"]);
    $[16] = getBreakpointValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== quote || $[19] !== t10) {
    t11 = <Text color="colorPalette.fg" fontFamily="longform" fontSize={t10} fontWeight={400} letterSpacing="normal">{quote}</Text>;
    $[18] = quote;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== getBreakpointValue) {
    t12 = getBreakpointValue([2, 4]);
    $[21] = getBreakpointValue;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== getBreakpointValue) {
    t13 = getBreakpointValue(["sm", "md"]);
    $[23] = getBreakpointValue;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Avatar.Fallback />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== personAvatarUrl) {
    t15 = <Avatar.Image src={personAvatarUrl} />;
    $[26] = personAvatarUrl;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t13 || $[29] !== t15) {
    t16 = <Avatar.Root boxShadow="base" size={t13}>{t14}{t15}</Avatar.Root>;
    $[28] = t13;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== getBreakpointValue) {
    t17 = getBreakpointValue(["md", "lg"]);
    $[31] = getBreakpointValue;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = personFullName ? personFullName : `${personFirstName} ${personLastName}`;
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <Text fontSize={t17} fontWeight={600}>{t18}</Text>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== getBreakpointValue) {
    t20 = getBreakpointValue(["xs", "sm"]);
    $[36] = getBreakpointValue;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  const t21 = personTitle && companyName ? `${personTitle}, ${companyName}` : personTitle || companyName;
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <Text color="colorPalette.fg" fontSize={t20} fontWeight={400} opacity={0.5}>{t21}</Text>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t19 || $[42] !== t22) {
    t23 = <VStack align="flex-start" gap={0}>{t19}{t22}</VStack>;
    $[41] = t19;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t12 || $[45] !== t16 || $[46] !== t23) {
    t24 = <HStack align="center" gap={t12} width="full">{t16}{t23}</HStack>;
    $[44] = t12;
    $[45] = t16;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== id || $[49] !== stackProps || $[50] !== t1 || $[51] !== t11 || $[52] !== t2 || $[53] !== t24 || $[54] !== t3 || $[55] !== t4 || $[56] !== t9) {
    t25 = <VStack alignItems="flex-start" alignSelf="stretch" borderRadius={t1} boxShadow={t2} gap={t3} id={id} justify="space-between" padding={t4} width="full" {...stackProps}>{t9}{t11}{t24}</VStack>;
    $[48] = id;
    $[49] = stackProps;
    $[50] = t1;
    $[51] = t11;
    $[52] = t2;
    $[53] = t24;
    $[54] = t3;
    $[55] = t4;
    $[56] = t9;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  return t25;
};
export default FGQuoteCard;